'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateTalonValue = updateTalonValue;

var _TalonActionTypes = require('../actionTypes/TalonActionTypes');

var _actionWithPayload = require('../utils/actionWithPayload');

var _actionWithPayload2 = _interopRequireDefault(_actionWithPayload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function updateTalonValue(data) {
  return function (dispatch) {
    dispatch((0, _actionWithPayload2.default)(_TalonActionTypes.UPDATE_TALON_VALUE, data));
  };
}